<template>
  <fieldset class="difficulty-profiles-field">
    <legend>Сложность по сезонам</legend>
    <div
      v-for="profile in localProfiles"
      :key="profile.season"
      class="difficulty-profile-row"
    >
      <span class="difficulty-profile-season">{{ seasonLabel(profile.season) }}</span>
      <label class="difficulty-profile-control">
        <span class="difficulty-profile-label">Колёса</span>
        <select v-model="profile.wheel_size" @change="emitProfiles">
          <option
            v-for="(label, value) in WHEEL_SIZE_LABELS"
            :key="value"
            :value="value"
          >
            {{ label }}
          </option>
        </select>
      </label>
      <label class="difficulty-profile-winch checkbox-label">
        <input v-model="profile.winch_required" type="checkbox" @change="emitProfiles" />
        Нужна лебёдка
      </label>
    </div>
  </fieldset>
</template>

<script setup>
import { ref, watch } from 'vue'
import {
  SEASONS,
  WHEEL_SIZE_LABELS,
  createDefaultDifficultyProfiles,
  seasonLabel,
} from '../utils/trackFormat'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => createDefaultDifficultyProfiles(),
  },
})

const emit = defineEmits(['update:modelValue'])

const localProfiles = ref(normalizeProfiles(props.modelValue))

watch(
  () => props.modelValue,
  (value) => {
    localProfiles.value = normalizeProfiles(value)
  },
  { deep: true }
)

function normalizeProfiles(profiles) {
  const bySeason = Object.fromEntries((profiles || []).map((profile) => [profile.season, profile]))

  return SEASONS.map((season) => ({
    season,
    wheel_size: bySeason[season]?.wheel_size || 'stock',
    winch_required: Boolean(bySeason[season]?.winch_required),
  }))
}

function emitProfiles() {
  emit(
    'update:modelValue',
    localProfiles.value.map((profile) => ({
      season: profile.season,
      wheel_size: profile.wheel_size,
      winch_required: profile.winch_required,
    }))
  )
}
</script>

<style scoped>
.difficulty-profiles-field {
  border: none;
  margin: 0;
  padding: 0;
}

.difficulty-profiles-field legend {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.difficulty-profile-row {
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.difficulty-profile-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.difficulty-profile-season {
  font-weight: 600;
}

.difficulty-profile-control {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.difficulty-profile-label {
  font-size: 0.875rem;
  color: #475569;
}

.difficulty-profile-control select {
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.difficulty-profile-winch {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}
</style>
